import dynamic from 'next/dynamic';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { TOUR_SECTION_HEIGHT } from 'src/modals/how-it-works/town-tour/town-tour.utils';

const Placeholder = () => (
  <div className="container">
    <div className="rounded border border-solid border-gray bg-light-gray">
      <div className={TOUR_SECTION_HEIGHT} />
      <div className="h-[242px] md:h-[194px]" />
    </div>
  </div>
);

// three.js only loads once the section is near, never with the page.
const TownTourSectionContent = dynamic(
  () =>
    import('src/modals/how-it-works/town-tour/town-tour-section-content').then(
      (mod) => mod.TownTourSectionContent,
    ),
  { ssr: false, loading: () => <Placeholder /> },
);

export function TownTourSection({ intro }: { intro?: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setNear(true);
          observer.disconnect();
        }
      },
      { rootMargin: '600px 0px' },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="w-full">
      {intro && (
        <div className="container mb-xl flex flex-col items-center text-center">
          {intro}
        </div>
      )}
      {near ? <TownTourSectionContent /> : <Placeholder />}
    </div>
  );
}
